export default __webpack_public_path__ + "static/media/LogoGrid.f8db8568.svg";